/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import _ from 'lodash';

import NewBotUploadAvatar from '../../../pages/NewBot/Components/NewBotUploadAvatar';
import actions from '../../../store/actions';
import { BotsCreators } from '../../../store/actions/bots';
import { UserActions } from '../../../store/actions/users';
import { debounce } from '../../../util/debounce';
import { formatFileToBackend } from '../../../pages/NewBot/Components/utils';

const INITIAL_STATE_VALUE = {
  title: '',
  img: '',
};

const SettingsGeneral = (props) => {
  const { bot, user } = props;

  const [botData, setBotData] = useState(INITIAL_STATE_VALUE);
  const [currentFile, setCurrentFile] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const [AttendanceHoursSettings, setAttendanceHoursSettings] = useState({
    fusoName: bot?.settings?.timezone?.fusoName || '',
    fuso: bot?.settings?.timezone?.fuso || '',
  });

  const textHandle = (e) => {
    const newTimezone = {
      ...AttendanceHoursSettings,
      fusoName: e.value,
      fuso: e.label,
    };
    setAttendanceHoursSettings(newTimezone);
  };

  const { title } = botData;
  const cannotEdit = user?.selectedCompany?.claim?.name === 'Viewer';

  useEffect(() => {
    if (bot && !_.isEmpty(bot)) {
      const { title: botTitle, img } = bot;
      const newBotData = {
        ...(botTitle && { title: botTitle }),
        ...(img && { img }),
      };
      if (img) {
        setCurrentFile(img);
      }
      setBotData(newBotData);
      setAttendanceHoursSettings({
        fusoName: bot?.settings?.timezone?.fusoName,
        fuso: bot?.settings?.timezone?.fuso,
      });
    }
  }, [bot]);

  useEffect(() => {
    if (currentFile) {
      const newBotData = {
        ...botData,
        ...(currentFile &&
          typeof currentFile !== 'string' && {
            img: formatFileToBackend(croppedImage, currentFile),
          }),
      };
      setBotData(newBotData);
    }
  }, [currentFile]);

  const onBotTitleInputChange = (event) => {
    const newBotData = { ...botData, title: event.target.value };
    setBotData(newBotData);
  };

  const onSaveButtonClick = () => {
    if (title.length === 0) {
      toastr.error('Erro', 'Nome do bot não pode ser vazio ');
      return;
    }

    debounce(botData, (value) => {
      const { _id: botId } = bot;

      if (botId) {
        const { img, title } = value;
        const newImage = croppedImage
          ? formatFileToBackend(croppedImage, currentFile)
          : img;
        const { updateBotGeneralInformation } = props;
        const payload = {
          title,
          fuso:
            AttendanceHoursSettings.fuso ||
            user?.selectedCompany?.timezone.fuso,
          fusoName:
            AttendanceHoursSettings.fusoName ||
            user?.selectedCompany?.timezone.fusoName,
          botId,
          ...(img && typeof newImage !== 'string' && { img: newImage }),
          ...(!croppedImage && !currentFile && img && { removeAvatar: true }),
        };

        updateBotGeneralInformation(payload);
      }
    });
  };

  return (
    <div className="settings-general-component-container">
      <div className="title-geral">Geral</div>
      <NewBotUploadAvatar
        croppedImage={croppedImage}
        setCroppedImage={setCroppedImage}
        currentFile={currentFile}
        setCurrentFile={setCurrentFile}
        containerClassName="new-bot-create-element-upload-style"
      />
      <div className="div-inp-geral-config">
        <span>
          <strong>Nome do bot:</strong>
        </span>
        <input
          value={title || ''}
          disabled={cannotEdit}
          onChange={(event) => onBotTitleInputChange(event)}
          maxLength={26}
          className="bot-name-input"
        />
        <div className="container-ipt-time-zone">
          <span>Fuso horário:</span>
          <TimezoneSelect
            value={AttendanceHoursSettings.fusoName}
            onChange={(e) => textHandle(e)}
            timezones={{
              ...allTimezones,
              'America/Noronha': 'Fernando de Noronha',
            }}
          />
        </div>
        <div>
          <button
            type="button"
            disabled={cannotEdit}
            className="btn btn-primary"
            onClick={onSaveButtonClick}
          >
            salvar
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...BotsCreators,
      ...UserActions,
      ...actions.previewBot,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(SettingsGeneral))
);
